import PropTypes from 'prop-types';
import styles from './ExperimentBreadcrumbs.module.css';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Breadcrumbs } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function ExperimentBreadcrumbs({ crumbs, pageTitle }) {
    const navigate = useNavigate();

    const handleNavigate = (e, href) => {
        e.preventDefault();
        navigate(href);
    };

    return (
        <Breadcrumbs
            aria-label="breadcrumb"
            className={styles.titleFontSize}
        >
            {crumbs.map((crumb, i) => !crumb.href
                ? crumb.label
                : (
                    <Link
                        key={`breadcrumbs-link-${i}`}
                        underline="hover"
                        color="inherit"
                        href={crumb.href}
                        onClick={(e) => handleNavigate(e, crumb.href)}
                    >
                        {crumb.label}
                    </Link>
                )
            )}
            <Typography
                className={styles.titleFontSize}
                sx={{
                    color: 'text.primary'
                }}
            >
                {pageTitle}
            </Typography>
        </Breadcrumbs>
    );
}

ExperimentBreadcrumbs.propTypes = {
    crumbs: PropTypes.arrayOf(PropTypes.shape({})),
};

export default ExperimentBreadcrumbs;
